// this file is automatically generated by git.version.ts script
export const versions = {version: '0.0.0', revision: 'c0afd56', branch: 'HEAD', dateTime:'2025-04-14T05:59'};